import { defineMessages } from 'react-intl-next';

import AiGenerativeAudioBriefingIcon from '@atlaskit/icon-lab/core/ai-generative-audio-briefing';
import TextAudioTranscriptIcon from '@atlaskit/icon-lab/core/text-audio-transcript';

import type { AudioFeature } from '../types/audioFeature';

const i18n = defineMessages({
	narrationLabel: {
		id: 'ai-audio.example.feature-toggle.narration-label',
		defaultMessage: 'Narration',
		description: 'Label for the narration feature',
	},
	briefingLabel: {
		id: 'ai-audio.example.feature-toggle.briefing-label',
		defaultMessage: 'Briefing',
		description: 'Label for the briefing feature',
	},
});

export const MOCK_FEATURE_LIST: [AudioFeature, AudioFeature] = [
	{
		name: 'briefing',
		translationString: i18n.briefingLabel,
		icon: AiGenerativeAudioBriefingIcon,
	},
	{
		name: 'narration',
		translationString: i18n.narrationLabel,
		icon: TextAudioTranscriptIcon,
	},
];
